import { BodyOfType } from './BodyOfType';

type Body = {};

export class LegacyBody implements BodyOfType<'legacy', Body> {
  type = 'legacy' as const;
}
